import { Box } from '@common-ui-library/atom';
import { styled, useTheme } from '@mui/material';
import { exportToCsv } from '@common-ui-library/shared';

export const StyledHeader = styled(Box)(({}) => {
  const theme = useTheme();
  return {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  };
});

export const handleExportToCsv = (data: any[], filename: string) =>
  exportToCsv(data, filename);
